import { BookOpen, CalendarRange, GraduationCap } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";
import { NextSessionsWidget } from "./NextSessionsWidget";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const ClassesPage = lazyPage(() => import("./ClassesPage"), "ClassesPage");
const ClassPage = lazyPage(() => import("./ClassPage"), "ClassPage");
const ProgramsPage = lazyPage(() => import("./ProgramsPage"), "ProgramsPage");
const MyEnrollmentsPage = lazyPage(() => import("./PublicPages"), "MyEnrollmentsPage");
const PublicAgendaPage = lazyPage(() => import("./PublicPages"), "PublicAgendaPage");

export default defineModuleUi({
  key: "programs",
  title: "Cursos, turmas e eventos",
  domain: "delivery",
  icon: GraduationCap,
  menu: [
    { path: "/entrega/turmas", label: "Turmas e eventos", minRole: "member", icon: CalendarRange, order: 20, keywords: "turma curso evento inscrição presença lista de espera d.o.s.e. workshop mentoria" },
    { path: "/entrega/programas", label: "Catálogo de programas", minRole: "member", icon: BookOpen, order: 22, keywords: "programa formação competências carga horária critérios de conclusão preço" },
  ],
  routes: [
    { path: "/entrega/turmas", element: <ClassesPage />, minRole: "member" },
    { path: "/entrega/turmas/:id", element: <ClassPage />, minRole: "member" },
    { path: "/entrega/programas", element: <ProgramsPage />, minRole: "member" },
  ],
  widgets: [{ key: "programs.next_sessions", title: "Próximas sessões de turma", minRole: "member", span: 1, order: 30, element: NextSessionsWidget }],
  publicRoutes: [
    { path: "/turmas", element: <PublicAgendaPage /> },
    { path: "/turmas/:org", element: <PublicAgendaPage /> },
  ],
  portal: {
    menu: [{ path: "/portal/inscricoes", label: "Turmas e inscrições", minRole: "client", icon: GraduationCap, order: 220 }],
    routes: [{ path: "/portal/inscricoes", element: <MyEnrollmentsPage />, minRole: "client" }],
  },
});
